module.exports = __webpack_public_path__ + "img/大师精讲堂@2x.6c959167.png";